import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Login from '@/components/Login'
import Friends from '@/components/Friends'
import Groups from '@/components/Groups'
import Workareas from '@/components/Workareas'
import Workarea from '@/components/Workarea'
import Group from '@/components/Group'
import Task from '@/components/Task'
import store from '@/vuex/store'
import Organisations from '@/components/Organisations'
import Organisation from '@/components/Organisation'
import User from '@/components/User'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Main',
            component: Main
        },
        {
            path: '/friends',
            name: 'Friends',
            component: Friends
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/groups',
            name: 'Groups',
            component: Groups
        },
        {
            path: '/workareas',
            name: 'Workareas',
            component: Workareas
        },
        {
            path: '/organisations',
            name: 'Organisations',
            component: Organisations
        },
        {
            path: '/organisation/:id',
            name: 'Organisation',
            component: Organisation
        },
        {
            path: '/workarea/:id',
            name: 'Workarea',
            component: Workarea
        },
        {
            path: '/group/:id',
            name: 'Group',
            component: Group
        },
        {
            path: '/task/:id',
            name: 'Task',
            component: Task
        },
        {
            path: '/user',
            name: 'User',
            component: User
        }
    ]
})

router.beforeEach(function (to, from, next) {
    if (to.name !== 'Login' && to.name !== 'Register' && !store.state.authentication.authenticated) {
        next('/login')
    } else {
        next()
    }
})

router.beforeEach(function (to, from, next) {
    if (from.name === 'Task') {
        store.commit('REMOVE_ACTIVE_TASK')
    }

    next()
})

router.onReady(() => {
    if (store.state.authentication.authenticated) {
        Vue.http.headers.common['Authorization'] = 'Bearer ' + store.state.authentication.token
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js